import * as React from 'react';
import { FormControl, Select as MuiSelect, InputBase, MenuItem, createStyles } from '@mui/material';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '@lean-body/components/styles';
import { styled } from '@mui/system';
const BootstrapInput = styled(InputBase)(() => createStyles({}));
export const SelectWithoutOutline = ({ selectOptions, value, containerClassObject, onChange }) => {
    const name = `${Math.random()}`;
    return (React.createElement(FormControl, { className: css(styles.container, containerClassObject) },
        React.createElement(MuiSelect, { IconComponent: () => null, value: value, onChange: onChange, input: React.createElement(BootstrapInput, null), inputProps: { name, id: `select-without-outline-${name}` }, classes: {
                root: css(styles.root),
                select: css(styles.select),
            } }, selectOptions.map((data, i) => {
            return (React.createElement(MenuItem, { key: i, value: data.value }, data.name));
        }))));
};
const styles = StyleSheet.create({
    container: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row',
    },
    root: {
        width: '100%',
        color: Colors.Black,
    },
    select: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 32,
        fontWeight: 'bold',
        lineHeight: '140%',
        letterSpacing: 2.56,
        padding: '0 0 20px',
        borderBottom: `2px solid ${Colors.BorderLightGray}`,
        borderRadius: 0,
    },
});
